/**
 * Vendored from `qrcode-generator@1.4.4`
 *   https://www.npmjs.com/package/qrcode-generator
 *   Copyright (c) 2009 Kazuhiko Arase — MIT licensed (see LICENSE).
 *
 * The upstream file is a UMD bundle (`qrcode.js`) that attaches a global
 * `qrcode` factory and additionally exports via AMD/CommonJS. We appended a
 * trailing `export default qrcode;` during vendoring so Vite/TS can consume
 * it as an ES module. We do not modify upstream behaviour — only add the
 * export line.
 *
 * This file is the typed entry point: it re-exports the factory with the
 * shape declared in `qrcode.d.ts` (also vendored verbatim from upstream).
 *
 * Why vendor instead of npm-installing: the SPA package opts out of runtime
 * `dependencies` to keep the bundle audit surface tight, and Vite inlines the
 * file straight into the chunk graph — no extra build config required.
 */

// @ts-expect-error — upstream qrcode.js is plain JS (no .d.ts companion that
// declares the ESM default export); the runtime export was added by our
// vendoring patch. The shape comes from the manual type declaration below.
import qrcodeFactory from './qrcode.js';

export type ErrorCorrectionLevel = 'L' | 'M' | 'Q' | 'H';

export interface QRCodeInstance {
  addData(data: string, mode?: string): void;
  make(): void;
  getModuleCount(): number;
  isDark(row: number, col: number): boolean;
}

export type QRCodeFactory = (
  typeNumber: number,
  errorCorrectionLevel: ErrorCorrectionLevel,
) => QRCodeInstance;

const factory = qrcodeFactory as unknown as QRCodeFactory;
export default factory;
